export interface VolunteerSettingsFormValue {
	enabled: boolean;
}

export function toVolunteerSettingsPayload(
	value: VolunteerSettingsFormValue | undefined,
	featureEnabled: boolean
): { enabled: boolean } | undefined {
	if (!featureEnabled) {
		return undefined;
	}
	return { enabled: Boolean(value?.enabled) };
}
